import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { Button, Row, Col, Form } from "react-bootstrap";
import swal from "sweetalert";
import { writeFile, utils } from "xlsx";
//import DashboardSidebar from "./DashboardSidebar";
import { Redirect, useHistory } from "react-router";
import { Pagination } from "../../admin/pg-report/PGReportTable";
import {
  BASE_URL_AGENT,
  BASE_URL_API,
  BASE_URL_API_TRANXT_API,
  BASE_URL_APISERVICES,
} from "../../utils/Constants";
import { COLOR_BACKGROUND_BODY } from "../../utils/Themer";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import {
  dateFormatter,
  formatDateDDMMYY,
  formatDateDDMMYYHHMM,
  twoDecimalPlaces,
} from "../../utils/utilFuctions";
import { withRouter } from "react-router-dom";
import { Dropdown, Card } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { validateTPin } from "../../utils/Validations";
import AddFunds from "../../../assets/svg/add_fund.svg";
import Pay_Bill from "../../../assets/svg/pay_bill.svg";
import Send_Money from "../../../assets/svg/send_money.svg";
import Upcomming_Transactions from "../../../assets/svg/upcomming_transactions.svg";
import Electricity from "../../../assets/svg/electricity.svg";
import PrepaidRecharge from "../../../assets/svg/prepaid_recharge.svg";
import { DROP_SHADOW, MONTHS } from "../../utils/CommonConfig";
import Debit from "../../../assets/images/Debit Card.png";
import credit from "../../../assets/images/Credit Card.png";
import Fund from "../../../assets/images/Fund.png";
import wallet from "../../../assets/images/Wallet 2 Wallet.png";
import Retailer from "../../../assets/images/Retailers.png";
import Select from "react-select";
import DatePicker from "react-datepicker";
import DistributorBusinessReport from "./DistributorBusinessReport";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { DIST_API_ENDPOINTS } from "../../utils/DistApiEndpoints";
import { adminAuth } from "../../config";

export const dropShadow = DROP_SHADOW;

const mapData = {
  BZ: 75.0,
  US: 56.25,
  AU: 15.45,
  GB: 25.0,
  RO: 10.25,
  GE: 33.25,
};

export const Dashboard = () => {
  const { username, password } = adminAuth;
  const InitialValues = { UserName: "" };
  const [formValues, setFormValues] = useState(InitialValues);
  const [formErrors, setFormErrors] = useState({});
  const [selectedOptions, setSelectedOptions] = useState();
  const [sidebarState, setSidebarState] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [Provider, setProvider] = useState([]);
  const [shopList, setShopList] = useState([]);
  const [pages, setPages] = useState(0);
  const [totalBusiness, setTotalBusiness] = useState(0);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [ShopObj, setShopObj] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [selectedData, setSelectedData] = useState({ id: "", oldBalance: "" });
  const [data, setData] = useState([]);
  const [transferData, setTransferData] = useState([]);
  const [startDate1, setStartDate1] = useState(new Date());

  const { Profileinfo } = useContext(GlobalContext);
  const [SendotpAdd, setSendotpAdd] = useState(true);
  const [SendotpRev, setSendotpRev] = useState(true);
  const history = useHistory();
  const [reconData, setReconData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showOffer, setShowOffer] = useState(false);

  const styles = document.createElement("style");
  styles.innerHTML = `
  @keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }
  
  /* For small devices */
  @media (max-width: 600px) {
    .offer-popup img {
      max-height: 70vh; /* keep inside viewport */
      object-fit: contain;
    }
  }
  
  /* For tablets */
  @media (min-width: 601px) and (max-width: 1024px) {
    .offer-popup img {
      max-height: 80vh;
    }
  }
  `;
  document.head.appendChild(styles);

  const accountOptions = [
    { value: "1", label: "Today" },
    { value: "7", label: "Weekly" },
    { value: "30", label: "Monthly" },
  ];

  const [businessData, setBusinessData] = useState({});

  const twoDecimalPlaces = (value) => {
    return Number(value).toFixed(2).toString();
  };

  const getUserBusiness = async (interval) => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username + ":" + password).toString("base64")
        );

      var raw = JSON.stringify({
        userid: user.ReferId,
        interval: interval,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.getUserBusiness}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode === "00" && data.data) {
        setBusinessData(data.data);
        setTransactionLoaderState(false);
      } else {
        console.log("Unexpected Response:", data);
        setTransactionLoaderState(false);
      }
    } catch (error) {
      console.log("API Error:", error);
      setTransactionLoaderState(false);
    }
  };

  const getDashboardData2 = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        service: "VENDOR PAYMENTS",
        fromDate: dateFormatter(startDate),
        toDate: dateFormatter(endDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${DIST_API_ENDPOINTS.getDashboardData2}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            console.log("API DATA:", result.data);
            setReconData(result.data);

            let business = 0;

            result.data.forEach(t => {
              if (t.success_amount)
                business += Number(t.success_amount)
            });
            setTotalBusiness(business)
            setTransactionLoaderState(false);
          } else {
            setReconData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  const getDashboardData = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        // userid: "BD1367",
        fromDate: dateFormatter(startDate),
        toDate: dateFormatter(endDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${DIST_API_ENDPOINTS.getDashboardData3}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.responseCode == "00") {
            setTransferData(result.data);
            setTransactionLoaderState(false);
          } else {
            setTransferData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserBusiness();
    getDashboardData();
    getDashboardData2();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  useEffect(() => {
    if (Profileinfo) {
      otpYes();
    }
  }, [Profileinfo]);

  const otpYes = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        mobile: Profileinfo?.mobile,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${DIST_API_ENDPOINTS.getUserConfigSettings}`,

        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        if (data.data.add_balance_otp == "N") {
          setSendotpAdd(false);
        }
        if (data.data.reverse_balance_otp == "N") {
          setSendotpRev(false);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    console.log(formErrors);
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      provider();
    }
  }, [formErrors]);

  const validate = (values) => {
    const errors = {};
    if (!values.UserName) {
      errors.UserName = "*User name is required!";
    }
    return errors;
  };

  // const str = sessionStorage.getItem('user');
  // const user = JSON.parse(str);

  const { token, myAccountInfo } = useContext(GlobalContext);
  console.log(myAccountInfo);

  const transactionHistoryData = {
    labels: ["Paypal", "Stripe", "Cash"],
    datasets: [
      {
        data: [55, 25, 20],
        backgroundColor: ["#111111", "#00d25b", "#ffab00"],
      },
    ],
  };

  function handleSelect(data) {
    setSelectedOptions(data);
  }

  const provider = () => {

    const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      userID: user.pk_user_id,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    try {
      fetch(
        `${BASE_URL_API}${DIST_API_ENDPOINTS.dist_get_provider_list}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status == 0) {
            setProvider(result.data);
            setDataToDisplay(result.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    provider();
  }, []);

  const shoplist = () => {
    var raw = JSON.stringify({
      UserID: user.pk_user_id,
    });

    var requestOptions = {
      method: "POST",
      body: raw,
      redirect: "follow",
    };

    try {
      fetch(
        `${BASE_URL_API_TRANXT_API}/api/distributor/dist_get_shoplist.aspx`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          setShopList(result.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  console.log(localStorage.getItem("accessToken"));
  console.log(token);
  useEffect(() => {
    console.log("calling");
    shoplist();
  }, []);

  const ExportToExcel = (fileName, Provider) => {
    let wb = utils.book_new();
    let ws = utils.json_to_sheet(Provider);
    utils.book_append_sheet(wb, ws, "sheet");
    writeFile(wb, `${fileName}.xlsx`);
  };

  useEffect(() => {
    let filteredData = Provider.filter((bank) => {
      let b = false;
      if (Provider.length > 0) {
        for (let key in Provider[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
    setTotal(filteredData.length);
    const startIdx = 0;
    const endIdx = offset - 1;
    filteredData = filteredData.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    setCurrentPage(1);
  }, [searchText]);

  useEffect(() => {
    let filteredData = Provider.filter((bank) => {
      let b = false;
      if (Provider.length > 0) {
        for (let key in Provider[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    console.log(filteredData);
    const startIdx = (currentPage - 1) * offset;
    const endIdx = currentPage * offset - 1;
    console.log({ startIdx, endIdx });
    filteredData = filteredData.filter((bank, idx) => {
      console.log(idx, idx <= endIdx && idx >= startIdx);
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    console.log({ startIdx, endIdx });
  }, [currentPage]);

  // did mount
  useEffect(() => {
    setPages(Math.floor((Provider.length + (offset - 1)) / offset));
    const startIdx = 0;
    const endIdx = offset - 1;
    setTotal(Provider.length);
    console.log(startIdx);
    const filteredData = Provider.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
  }, [Provider, offset]);

  const ShopWithId = () => {
    const getShopsObject = Provider.filter((data) => {
      return formValues.UserName == data.pk_user_id;
    });
    setShopObj(getShopsObject);
  };

  const requestParentFundRequest = async (childId) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        sender: user.ReferId,
        receiver: childId,
        type: "1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${DIST_API_ENDPOINTS.fund_request_submit}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        swal("Success", data.msg, "success");
      } else {
        swal("Failed", data.msg, "error");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const reset = () => {
    setShopObj([]);
    setFormValues({ ...formValues, UserName: "" });
  };

  useEffect(() => {
    ShopWithId();
  }, [formValues.UserName]);

  const positionStyle = {
    position: "absolute",
    top: -28,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
    borderRadius: "0.2rem",
  };
  const positionStyle1 = {
    position: "absolute",
    top: -58,
    left: -15,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
    borderRadius: "0.2rem",
  };
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const fetchData = () => {
    getDashboardData(startDate, endDate);
    getDashboardData2(startDate, endDate);
  };

  return (
    <GlobalContext.Consumer>
      {(context) =>
        context.user == null || context.user.UserType !== "3" ? (
          <Redirect to="/" />
        ) : (
          <React.Fragment>
            {showOffer && (
              <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                  backgroundColor: "rgba(0,0,0,0.8)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                  animation: "slideUp 0.6s ease forwards",
                  padding: "10px",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "90%",
                    maxWidth: "500px",
                  }}
                >

                  <button
                    onClick={() => setShowOffer(false)}
                    style={{
                      position: "absolute",
                      top: "-5%",
                      right: "-5%",
                      background: "white",
                      border: "none",
                      fontSize: "clamp(16px, 2vw, 22px)",
                      fontWeight: "bold",
                      color: "black",
                      borderRadius: "50%",
                      width: "clamp(30px, 8vw, 40px)",
                      height: "clamp(30px, 8vw, 40px)",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    ✖
                  </button>

                  <img
                    src="https://bumppy.in/billpunch/api/v1/uploads/images/img_bumppyDmt_offer_png.png"
                    alt="Offer"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.5)",
                    }}
                  />
                </div>
              </div>
            )}
            <div className="row m-2 p-0 align-items-center">
              <div className="col-4 m-0 p-0">
                <div
                  className="m-0 p-0 pl-3"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "32px",
                    fontWeight: "600",
                    lineHeight: "48px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    padding: "0px",
                    background: "#FFFFFF",
                    color: "#0E2148",
                    fontWeight: "bolder",
                    fontfamily: "Poppins !impotent",
                    fontSize: "28px",
                  }}
                >
                  Dashboard Data
                </div>
              </div>

              <div className="col-8 pt-3 m-0 p-0 ">
                <div className="row pr-2 m-0 p-0 justify-content-end">
                  <div
                    className="pr-1 pl-2 p-0 m-0"
                    style={{ width: "18%", height: "20%" }}
                  >
                    <Form.Group className="p-0 m-0">
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        className="form-control rounded-100"
                        placeholderText="Start Date"
                      />
                    </Form.Group>
                  </div>
                  <div
                    className="px-1 p-0 m-0"
                    style={{ width: "18%", height: "20%" }}
                  >
                    <Form.Group className="p-0 m-0">
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className="form-control rounded-100"
                        placeholderText="End Date"
                      />
                    </Form.Group>
                  </div>
                  <div
                    className="pl-1 p-0 m-0"
                    style={{ width: "14%", height: "20%" }}
                  >
                    <Form.Group>
                      <Button
                        className="rounded-100 mt-4 btn btn-lg btn-block"
                        style={{ background: "#0E2148", color: "white" }}
                        onClick={fetchData}
                      >
                        {"Search"}
                      </Button>
                    </Form.Group>
                  </div>
                  {/* <div className="m-0 p-0 hover-container"
 style={{ cursor: "pointer" }}
 onClick={() => {
 ExportToExcel("Fund Report", data);
 }}
 >
 <img className="pl-1"
 src={require("../../../assets/images/download Icon.png")}
 style={{ width: `3.5rem`, height: '85%' }}
 />
 <div style={positionStyle} className="hover-text bg-dark ">Export to Excel</div>
 </div> */}
                </div>
              </div>
            </div>
            <div
              class="summary-section "
            >
              <div
                className="card "
                style={{
                  background: "linear-gradient(45deg,#F0F6FB 0%,#F0F6FB 100%)",
                  borderRadius: "1rem",
                  boxShadow:
                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                  marginLeft: "20px",
                  marginTop: "15px",
                }}
              >
                <h4 style={{ color: "#0E2148" }}>
                  <b>Overview</b>
                </h4>
                <div className="summary-grid">
                  <div>
                    <strong>Total Business</strong>
                    <br />
                    <div style={{ color: "green" }}>
                      {twoDecimalPlaces(totalBusiness) || "0.00"}

                    </div>
                  </div>

                </div>
              </div>

              <div
                className="card "
                style={{
                  background: "linear-gradient(45deg,#F0F6FB 0%,#F0F6FB 100%)",
                  borderRadius: "1rem",
                  boxShadow:
                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                <h4 style={{ color: "#0E2148" }}>
                  <b>Network Business </b>
                </h4>
                <div className="summary-grid">
                  <div>
                    <strong>Total Commission</strong>
                    <br />
                    <div style={{ color: "green" }}>
                      {twoDecimalPlaces(transferData.totalCommission) || "0.00"}

                    </div>
                  </div>
                  <div>
                    <strong>Total Charges</strong>
                    <br />
                    <div style={{ color: "green" }}>
                      {twoDecimalPlaces(transferData.totalCharges) || "0.00"}

                    </div>
                  </div>
                </div>
              </div>

              <div
                className="card "
                style={{
                  background: "linear-gradient(45deg,#F0F6FB 0%,#F0F6FB 100%)",
                  borderRadius: "1rem",
                  boxShadow:
                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                  marginRight: "20px",
                  marginTop: "15px",
                }}
              >
                <h4 style={{ color: "#0E2148" }}>
                  <b>Wallet Transfer </b>
                </h4>
                <div className="summary-grid">
                  <div>
                    <strong>Wallet Total In</strong>
                    <br />
                    <div style={{ color: "green" }}>
                      {twoDecimalPlaces(transferData.totalIn) || "0.00"}

                    </div>
                  </div>
                  <div>
                    <strong>Wallet Total Out</strong>
                    <br />
                    <div style={{ color: "green" }}>
                      {twoDecimalPlaces(transferData.totalOut) || "0.00"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0">
              <QuickAccess />
            </div>

            <div class="customers-panel">
              <div
                className="col-12"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  padding: "24px",
                  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div className=" scroll-inner admin-fix-width borderless-table ">
                  <table
                    className="my-table transparent-table text-center border-bottom"
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      border: "0px",
                      overflow: "auto",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan={12}
                          style={{
                            backgroundColor: "#7F8CAA",
                            color: "#ffffff",
                            padding: "16px",
                            textAlign: "center",
                            borderRadius: "12px",
                            fontSize: "15px",
                            fontWeight: "500",
                          }}
                        >
                          Business Summary
                        </th>
                      </tr>
                      <tr
                        className="borderless-table text-center border-bottom"
                        style={{ backgroundColor: "#f8f9fc" }}
                      >
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "8px 0 0 8px",
                          }}
                        >
                          Service
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                          }}
                        >
                          Success Count
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "8px 0 0 8px",
                          }}
                        >
                          Success amount
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "0 8px 8px 0",
                          }}
                        >
                          Failed Count
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                          }}
                        >
                          failed amount
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "8px 0 0 8px",
                          }}
                        >
                          Pending Count
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "0 8px 8px 0",
                          }}
                        >
                          Pending amount
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                          }}
                        >
                          Refund
                        </th>
                        <th
                          className="my-table transparent-table text-center border-bottom "
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            letterSpacing: "0em",
                            textAlign: "center",
                            backgroundColor: "#f8f9fc",
                            borderRadius: "0 8px 8px 0",
                          }}
                        >
                          Refund amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {Array.isArray(reconData) && reconData.length > 0 ? ( */}
                      {reconData.map((e, index) => (
                        <tr key={index} className="border-bottom clickable-row">
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                            }}
                          >
                            {e.service}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#27ae60",
                            }}
                          >
                            {e.success}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#27ae60",
                            }}
                          >
                            {twoDecimalPlaces(e.success_amount)}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#c0392b",
                            }}
                          >
                            {e.failed}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#c0392b",
                            }}
                          >
                            ₹{twoDecimalPlaces(e.failed_amount)}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                            }}
                          >
                            {e.pending}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                            }}
                          >
                            ₹{twoDecimalPlaces(e.pending_amount)}
                          </td>
                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                              color: "#27ae60",
                            }}
                          >
                            {e.refund}
                          </td>

                          <td
                            className="text-center border-bottom"
                            style={{
                              fontSize: "0.8rem",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0em",
                              textAlign: "center",
                            }}
                          >
                            ₹{twoDecimalPlaces(e.refund_amount)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
      }
    </GlobalContext.Consumer>
  );
};

export default Dashboard;

const QuickAccess = ({ discription }) => {
  let basicAuth = JSON.parse(sessionStorage.getItem("basic_auth"));
  const [formErrors, setFormErrors] = useState({});
  const [fetchBillModal, setFetchBillModal] = useState(false);
  const [date, setDate] = useState(new Date());
  const [amount, setAmount] = useState("");
  const [Tpin, setTpin] = useState("");
  const [serviceSelected, setServiceSelected] = useState(5);
  const [enableSmartCollectButtonState, setEnableSmartCollectButtonState] =
    useState(true);
  const {
    token,
    myAccountInfo,
    user,
    setTransactionLoaderState,
    checkWalletBeforeBBPSBillPay,
    Profileinfo,
  } = useContext(GlobalContext);
  const [dashboardInfo, setDashboardInfo] = useState({});
  if (!basicAuth) {
    basicAuth = { username: "productionenCoding@bumppy.com", password: "YnVtcHB5LmNvbS9wcml2YWN5cG9saWN5" };
  }
  const { username, password } = basicAuth;
  const [state, setState] = useState({
    provider: "",
    consumer: "",
    mobileNumber: "",
    custparams: "",
  });
  // get all operators

  useEffect(() => { }, [serviceSelected]);
  console.log(state.provider);
  return (
    <div className=" w-100">
      <div
        style={{
          background: "linear-gradient(45deg,#F0F6FB 0%,#F0F6FB 100%)",
          borderRadius: "1rem",
          boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
        }}
        className="m-1 rouded-3 p-2"
      >
        <div className="row">
          <h3 className="text-dark ml-3">Quick Access</h3>
        </div>
        <div
          className="row rouded-3 justify-content-start m-0 rounded-3"
          style={{
            background: "linear-gradient(45deg,#F0F6FB 0%,#F0F6FB 100%)",
          }}
        >
          <BBPSIconCard
            redirect={"/distributor/CreditFunds"}
            image={credit}
            title={"Credit"}
            selected={serviceSelected == 1}
          />
          <BBPSIconCard
            redirect={"/distributor/DebitFunds"}
            image={Debit}
            title={"Debit"}
            selected={serviceSelected == 2}
          />
          <BBPSIconCard
            redirect={"/distributor/Report/FundReport"}
            image={Fund}
            title={"Funds"}
            selected={serviceSelected == 2}
          />
          <BBPSIconCard
            redirect={"/distributor/PaymineWallet/WalletToWalletTransfer"}
            image={wallet}
            title={"Wallet to Wallet"}
            selected={serviceSelected == 3}
          />
          <BBPSIconCard
            redirect={"/distributor/view-retailer"}
            image={Retailer}
            title={"Retailer"}
            selected={serviceSelected == 4}
          />
        </div>
      </div>

      <DistributorBusinessReport />
    </div>
  );
};

const BBPSIconCard = ({ image, title, selected, onClick, redirect }) => {
  const history = useHistory();
  const redirectTo = () => {
    if (redirect) history.push(redirect);
  };
  return (
    <div
      className="col-md-2 col-sm-3 col-4 d-flex flex-column justify-content-start align-items-center p-2"
      style={{ background: "transparent" }}
      onClick={() => history.push(redirect)}
    >
      <div
        style={{
          borderRadius: "3rem",
          border: selected ? "2px solid #3C79F5" : "2px solid #FFF",
          background: "#FFF",
          display: "inline-block",
          padding: "1rem",
          boxShadow: dropShadow,
        }}
      >
        <img
          src={image}
          style={{ height: "2rem", width: "2rem", color: "#EC5665" }}
          className="bbps_icon"
        />
      </div>

      <span
        className="text-dark text-center mt-2"
        style={{
          fontSize: ".8rem",
          fontWeight: "400",
          fontWeight: selected ? "700" : "400",
        }}
      >
        {title}
      </span>
    </div>
  );
};
